import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {
	Validator
} from 'vee-validate'

export default {
	name: 'client',
	components: {
		Paginate
	},
	data: function() {
		return {
			modalShow: false,
			listProductData: [],
			pageno: 0,
			pagecount: 0,
			whid: '',
			sectionid: '',
			lineno: '',
			rackno: '',
			rackid: '',
			rackpriority: '',
			terms: false,
			id: '',
			status: '',
			newActionMsg: '',
			rackstatus: '',
			data: '',
			changestatus: '',
		}
	},
	created: function() {},
	// when a page loads,mounted() will be call
	mounted() {
		this.pageno = 0
		this.getProductData()
	},
	methods: {
		//listing all data
		getProductData() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');

			this.input = ({
				offset: this.pageno,
				limit: 10,
				whid: this.whid,
				sectionid: this.sectionid,

			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getProductrackmasterList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					this.listProductData = result.data.rows
					let totalRows = result.data.count
					if (totalRows < 10) {
						this.pagecount = 1
					} else {
						this.pagecount = Math.ceil(totalRows / 10)
					}
				}, error => {
					console.error(error)
				})
		},


		getPaginationData(pageNum) {
			this.pageno = (pageNum - 1) * 10
			this.getProductData()
		},

		//status details
		getStatusRowData(data) {
			//console.log(data.rackstatus);
			this.modalShow = true;
			this.rackno = data.rackno;
			this.whid = data.whid;
			if (data.rackstatus.trim() == "lock") {
				this.newStatus = "unlock";
			} else {
				this.newStatus = "lock";
			}
		},
		// status change
		changeStatus() {
			let userToken = window.localStorage.getItem('userToken')
			let myStr = userToken.replace(/"/g, '');
			this.input = ({
				status: this.newStatus,
				rackstatus: '',
				rackno: this.rackno,
				whid: this.whid,
				actionType: ''
			});
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'updateProductOrderStatus',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					//console.log(result.data);
					if (result.data.status == 200) {
						this.listProductData = this.getProductData();
						this.displayMsg = "success";
						this.successErrorMsg = "Updated Successfully.";
						this.getProductData();
					}
					//debugger
					//this.listPurchaseOrderData = result.data;
				}, error => {
					//console.log(error);
					console.error(error);
					this.successErrorMsg = "Does not Updated, Try again.";
				})
		},


		//validate all form fields on onsubmit()

	}
}


// WEBPACK FOOTER //
// ./src/views/components/productracklist/productracklist.component.js